// @ts-ignore
import * as React from "react";

import { ActionItem } from "../ActionItem/ActionItem";
import { feedbackButtonTourStep } from "../Tour/Steps/FeedbackButton";
import { useTourStepRef } from "../../Internals/TourManagement/UseTourStepRef";

import { PopupAction, PopupItem } from "./FeedbackButton.styles";

interface FeedbackButtonProps {
    onClick: () => void;
    place: "panel" | "footer";
    isPopupPanel: boolean;
}

export function FeedbackButton(props: FeedbackButtonProps): JSX.Element {
    const tourRef = useTourStepRef(() => ({
        ...feedbackButtonTourStep,
        group: props.isPopupPanel ? ["menu"] : ["panel"],
    }));

    if (props.isPopupPanel) {
        return (
            <PopupItem ref={tourRef}>
                <PopupAction onClick={props.onClick}>Оставить отзыв</PopupAction>
            </PopupItem>
        );
    }
    return (
        <ActionItem
            ref={tourRef}
            icon="StarIcon"
            place={props.place}
            text={props.place === "footer" ? "Оценить" : "Оставить отзыв"}
            data-tid={"panel-action-feedback"}
            onClick={props.onClick}
        />
    );
}
